/** HTML-escape a string for safe innerHTML interpolation (also escapes single quotes). */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  })[c]!);
}
export { escapeHtml as esc };

/** Extract a human message from an API error response. */
export function msg(err: unknown, fallback = 'Something went wrong'): string {
  const e = err as { response?: { data?: { message?: string | string[] } }; message?: string };
  const m = e?.response?.data?.message;
  if (Array.isArray(m)) return m[0] ?? fallback;
  return m ?? e?.message ?? fallback;
}
